export default __webpack_public_path__ + "static/media/server.532ea75d.svg";